module.exports = __webpack_public_path__ + "img/74.3eb2672c.jpg";